export const getIconStyles = () => ({
  fontSize: 16,
  strokeWidth: 20,
  stroke: '#222',
});
